import { URLS } from '_constants';

// Survey drafts are keyed `userId:formId:retailerId:assignmentId` by hooks/useSurveyDraft,
// with the literal string 'none' when the survey was started without an assignment.
export const NO_ASSIGNMENT = 'none';

export const parseSurveyDraftKey = (key) => {
  if (typeof key !== 'string') return null;
  const [userId, formId, retailerId, assignmentId] = key.split(':');
  if (!userId || !formId || !retailerId) return null;
  return {
    userId,
    formId,
    retailerId,
    // Normalised to null so callers don't have to know about the sentinel.
    assignmentId: !assignmentId || assignmentId === NO_ASSIGNMENT ? null : assignmentId,
  };
};

/**
 * Resume URL for a draft.
 *
 * The two survey routes take their params in OPPOSITE orders, and the two-segment one is
 * declared first in routes/private.js, so it wins the <Switch> for any two-segment URL:
 *
 *   /survey/:id/:formId                 <- retailer first  (declared first)
 *   /survey/:formId/:id/:assignmentId   <- form first
 *
 * So a draft with an assignment is form-first, and one without has to be retailer-first.
 * Emitting form-first for the no-assignment case would match the retailer-first route and
 * silently transpose the two ids, rebuilding a *different* draft key — the user would land
 * on an empty survey. Mirrors the existing builders in CampaignView's RetailerCell (three
 * segments) and modules/SurveyModal (two).
 */
export const buildSurveyDraftUrl = ({ formId, retailerId, assignmentId }) => {
  if (!formId || !retailerId) return '';
  if (assignmentId) return `${URLS.survey}/${formId}/${retailerId}/${assignmentId}`;
  return `${URLS.survey}/${retailerId}/${formId}`;
};
